import { HREmpMultipleDoc } from './hrEmpMultipleDocs';
import { HrEmpEducationDetails } from './hrEmpEducationDtls';
import { ProfileVerificationStatus } from './ProfileVerificationStatus';

export class HrEmpEducationInfo{
  educationDetails: HrEmpEducationDetails[] = [];
  AdditionalQualifications: HREmpMultipleDoc[] = [];
  isFromProfile:boolean;
}
export class EmpAdditionalQualifications {
  Name: string;
  additionalDocs: HREmpMultipleDoc[] = [];
}
